import Component from '../core/Component'
import enquire from 'enquire.js'
import { queries } from '../core/config'

const ACTIVE = 'is-active'

export default class footerNav extends Component {

    constructor(element) {
        super(element)

        this.isMobile = true

        this.enquireHandler = {
            match: () => {
                this.isMobile = false
            },
            unmatch: () => {
                this.isMobile = true
            }
        }
    }

    prepare() {
        this.element.addEventListener('click', this.handleClick)

        enquire.register(queries.xlargeUp, this.enquireHandler)
    }

    handleClick = () => {
        if (this.isMobile) {
            event.preventDefault();
            this.element.parentNode.classList.toggle(ACTIVE)
        }
    }
}
